import CustomSlider from 'pages/landing/common/CustomSlider/CustomSlider';
import { Container } from 'react-bootstrap';
import CardImageOne from 'assets/img/landing/whoOne.png';
import Unicon from 'components/base/Unicon';
import { UilArrowUpRight } from '@iconscout/react-unicons';

function WhoCrudBeat() {
  const CardOne = () => {
    return (
      <div className="p-lg-0 p-4 bg-body">
        <p className="fs-lg-5 fs-6 fw-bold">Launch Your Tech Career</p>
        <p className="m-0">Build a standout tech portfolio.</p>
        <p className="mb-6">
          Earn certifications and{' '}
          <span className="text-primary">connect with top recruiters.</span>
        </p>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Enrollment by Your College
            </p>
            <p className="mb-4 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Your college enrolls you on CRUDBeat; login credentials emailed
              securely.
            </p>
          </div>
        </div>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Earn Certifications & Get Noticed
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Earn global tech certifications; build a portfolio showcasing
              projects and achievements.
            </p>
          </div>
        </div>
        <div className="d-flex mb-6">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Network with Industry Experts
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Connect with industry leaders and professionals through exclusive
              webinars and events.
            </p>
          </div>
        </div>
      </div>
    );
  };
  const CardTwo = () => {
    return (
      <div className="p-lg-0 p-4 bg-body">
        <p className="fs-lg-5 fs-6 fw-bold">
          Access Top Tech Talent Effortlessly
        </p>
        <p className="m-0">
          Discover pre-assessed, skilled candidates ready to join your team.
        </p>
        <p className="mb-6">
          Build your workforce with{' '}
          <span className="text-primary">
            the best tech minds from around the globe.
          </span>
        </p>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Access Pre-Assessed Talent
            </p>
            <p className="mb-4 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Find skilled candidates ready to meet your hiring needs with
              pre-assessed profiles.
            </p>
          </div>
        </div>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Host Challenges & Job Fairs
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Engage with potential hires through coding challenges, interviews,
              and campus events.
            </p>
          </div>
        </div>
        <div className="d-flex mb-6">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Access a Global Talent Pool
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Tap into a diverse network of tech professionals from all over the
              world, ready to bring their skills to your projects.
            </p>
          </div>
        </div>
      </div>
    );
  };
  const CardThree = () => {
    return (
      <div className="p-lg-0 p-4 bg-body">
        <p className="fs-lg-5 fs-6 fw-bold">
          Empower Your Institution and Students
        </p>
        <p className="m-0">
          Seamlessly enroll your students on CRUDBeat for better placement
          opportunities.
        </p>
        <p className="mb-6">
          Collaborate with top companies to bring{' '}
          <span className="text-primary">
            exclusive job opportunities to your campus.
          </span>
        </p>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Seamless Student Enrollment
            </p>
            <p className="mb-4 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Easily enroll your students onto CRUDBeat and manage their
              progress effortlessly.
            </p>
          </div>
        </div>
        <div className="d-flex">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Organize Tech Events & Job Fairs
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Host workshops, webinars, and recruitment drives to enhance
              student career opportunities.
            </p>
          </div>
        </div>
        <div className="d-flex mb-6">
          <div>
            <div className="bg-primary p-1 rounded-circle me-3 fs-9">
              <Unicon icon={UilArrowUpRight} color="white" size={20} />
            </div>
          </div>
          <div>
            <p className="mb-1 fs-lg-7 fs-md-7 fs-8 fw-bold">
              Partner with Leading Companies
            </p>
            <p className="mb-lg-4 mb-0 text-body-secondary fs-lg-8 fs-md-8 fs-9">
              Collaborate with top tech companies to offer students job
              placements and internships directly from your campus.
            </p>
          </div>
        </div>
      </div>
    );
  };

  const cards = [
    { SideContent: <CardOne />, image: CardImageOne, label: 'Students' },
    { SideContent: <CardTwo />, image: CardImageOne, label: 'Recruiters' },
    { SideContent: <CardThree />, image: CardImageOne, label: 'College' }
  ];
  return (
    <Container fluid className="px-lg-8 py-10 bg-body-highlight customSlider">
      <p className="fs-5 fw-bolder text-center">Who is Crud Beat For?</p>
      <CustomSlider cardsData={cards} />
    </Container>
  );
}

export default WhoCrudBeat;
